import { render, staticRenderFns } from "./PreviewItem.vue?vue&type=template&id=38d6a294&scoped=true&lang=pug&"
import script from "./PreviewItem.vue?vue&type=script&lang=js&"
export * from "./PreviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6a294",
  null
  
)

export default component.exports